import React from "react";
import strings from "../../core/translate";

/** Shown instead of an empty table or grid: says what is missing and why. */
const EmptyState = ({ icon = "nc-icon nc-box", title, text, children }) => (
  <div className="page-empty">
    <i className={`page-empty__icon ${icon}`} />
    <p className="page-empty__title">{title || strings.nodata}</p>
    {text && <p className="page-empty__text">{text}</p>}
    {children && <div className="mt-3">{children}</div>}
  </div>
);

export default EmptyState;
